import { render } from "./CloseModalBtn.vue?vue&type=template&id=113f675f&scoped=true"
import script from "./CloseModalBtn.vue?vue&type=script&lang=js"
export * from "./CloseModalBtn.vue?vue&type=script&lang=js"

import "./CloseModalBtn.vue?vue&type=style&index=0&id=113f675f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113f675f"]])

export default __exports__